import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import AccountForm from './AccountForm';
import {
  initOrganizationRequest,
  createOrganizationRequest, initOrganizationClear,
} from '../../../store/modules/organizations/actions';
import { useActionDispatcher } from '../../../hooks';
import {
  selectOrganizationForm,
} from '../../../store/modules/organizations/selectors';
import { getRoleFromPath } from '../../../utility/path';
import history from '../../../history';
import SavedSearchService, { SavedSearchPages } from '../../../services/SavedSearchService';

const OrganizationCreate = () => {
  const dispatch = useDispatch();

  const createOrganization = useActionDispatcher(createOrganizationRequest);

  const organizationForm = useSelector(selectOrganizationForm);

  // const { data } = useSelector(selectOrganization);

  useEffect(() => {
    dispatch(initOrganizationRequest());
    return () => {
      dispatch(initOrganizationClear());
    };
  }, [dispatch]);

  useEffect(() => {
    if (organizationForm.data === null && !organizationForm.loading) {
      dispatch(initOrganizationRequest());
    }
    const role = getRoleFromPath(history.location.pathname);
    dispatch(push(`/dashboard/${role}/organizations/new`));
  }, [dispatch, organizationForm]);

  return (
    <AccountForm
      creatingMode
      record={organizationForm}
      onSubmit={createOrganization}
      getTitle={() => SavedSearchService.getValue(SavedSearchPages.Organization)}
    />
  );
};

export default OrganizationCreate;
